<mat-spinner *ngIf="isLoading()"></mat-spinner>

<div class="container py-4">
<!-- Header -->
<div class="d-flex justify-content-between align-items-center mb-3">
<h4 class="m-0">Budgets sent to our clients</h4>
<div class="d-flex align-items-center">
    <button class="btn btn-link text-decoration-none p-0 me-3">
    <i class="bi bi-arrow-clockwise fs-5"></i>
    </button>
    <a href="#" class="text-primary text-decoration-none">View All</a>
</div>
</div>

<!-- List -->
<ul class="list-group" *ngIf="!isLoading()">
<!-- Item -->
<li class="list-group-item d-flex align-items-center justify-content-between" *ngFor="let cotizacion of getBudgetList()">
    <div class="d-flex align-items-center">
    <div class="me-3">
        <img *ngIf="cotizacion.imageUrl" src="{{getPhotoUrl(cotizacion.imageUrl)}}" class="profile-image" alt="user">
    </div>
    <div>
        <h6 class="mb-1 fw-bold">{{cotizacion.name}} {{cotizacion.lastname}}</h6>
        <p class="mb-0 text-muted">{{cotizacion.goal}}</p>
    </div>
    </div>
    <div class="d-flex align-items-center">
    <button mat-icon-button class="btn btn-outline-primary btn-sm me-2" color="primary" (click)="copyToClipBoard(cotizacion)">
        <mat-icon>content_copy</mat-icon>
        </button>
    <a href="javascript:void(0)" class="badge bg-dark text-white" (click)="openLink(cotizacion)" class="button button-fill button-round color-dark button-icon-left author-follow">
        #{{cotizacion.code}}
    </a>
    </div>
</li>
</ul>
</div>